import React, { useContext, useRef } from "react";
import Link from "next/link";
import cls from "./header.module.scss";
import { BrandLogo, BrandLogoDark } from "components/icons";
import { ThemeContext } from "contexts/theme/theme.context";
import dynamic from "next/dynamic";
import SearchContainer from "containers/searchContainer/searchContainer";
import { useAuth } from "contexts/auth/auth.context";
import useModal from "hooks/useModal";
import AddressContainer from "containers/addressContainer/addressContainer";
import Image from "next/image";
import CartButton from "components/cartButton/cartButton";
import { useTranslation } from "react-i18next";
import NotificationStats from "components/notificationStats/notificationStats";
import { useRouter } from "next/router";

const AppDrawer = dynamic(() => import("components/appDrawer/appDrawer"));
const ProfileDropdown = dynamic(
  () => import("components/profileDropdown/profileDropdown"),
);

export default function Header() {
  const { t } = useTranslation();
  const { pathname } = useRouter();
  const { isDarkMode } = useContext(ThemeContext);
  const { isAuthenticated, user, openAuthModal } = useAuth();
  const [appDrawer, handleOpenAppDrawer, handleCloseAppDrawer] = useModal();

  const searchContainerRef = useRef(null);

  return (
    <div className={`${cls.container} ${pathname !== "/" && cls.bordered}`}>
      <div className="container">
        <header className={cls.header}>
          <div className={cls.navItem}>
            {!isAuthenticated && (
              <button className={cls.menuBtn} onClick={handleOpenAppDrawer}>
                <Image
                  src="/images/menu.svg"
                  alt="menu"
                  width={20}
                  height={20}
                />
              </button>
            )}
            <Link href="/" className={cls.brandLogo}>
              {isDarkMode ? <BrandLogoDark /> : <BrandLogo />}
            </Link>
          </div>
          <div
            className={`${cls.navItem} ${cls.searchBar}`}
            ref={searchContainerRef}
          >
            <div className={cls.search}>
              <SearchContainer searchContainerRef={searchContainerRef} />
            </div>
          </div>
          <div className={cls.navItem}>
            <AddressContainer />
          </div>
          <NotificationStats />
          <div className={cls.navItem}>
            <CartButton />
          </div>
          {isAuthenticated ? (
            <ProfileDropdown data={user} />
          ) : (
            <button type="button" onClick={openAuthModal} className={cls.login}>
              {t("login")}
            </button>
          )}
        </header>
      </div>
      <AppDrawer open={appDrawer} handleClose={handleCloseAppDrawer} />
    </div>
  );
}
